import React from 'react';
import { SectionCta } from './SectionCta';
import { clarityQuestions } from '../data/content';
export function ClarityQuestions() {
  return <section className="bg-navy-900 px-5 py-16 sm:py-24" aria-labelledby="clarity-title" data-id="element-99" data-mp="3jr13znck04ob">
      <div className="mx-auto max-w-3xl" data-id="element-100" data-mp="3nqt7hln3bkmt">
        <h2 id="clarity-title" className="text-center font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-101" data-mp="3sr7f52ks4skb">
          And it shouldn't have to feel <span className="text-radar" data-id="element-102" data-mp="6k94u29rhj0u">this way.</span>
        </h2>
        <div className="mt-8 space-y-4 text-center text-lg leading-relaxed text-white/85" data-id="element-103" data-mp="6ielgse51yyv">
          <p data-id="element-104" data-mp="bbhcotvg0wbw">Because the problem isn't necessarily that you don't know enough.</p>
          <p className="text-xl font-semibold text-white" data-id="element-105" data-mp="fb9fsr22ia9v">
            The problem is that clinical knowledge is difficult to access when you need it most.
          </p>
          <p data-id="element-106" data-mp="pa7c4g5qj83f">During a procedure, you don't need another 300-page textbook.</p>
          <p className="font-semibold text-radar" data-id="element-107" data-mp="2fe1t79qmbw8u">You need to recognize:</p>
        </div>

        <ol className="mt-8 space-y-3" data-id="element-108" data-mp="2fbp2o86sodk6">
          {clarityQuestions.map((q, i) => <li key={q} className="flex items-center gap-4 rounded-2xl bg-white/[0.06] p-4 ring-1 ring-white/10" data-id="element-109" data-mp="2ah310wqilzda" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-radar font-display text-lg font-bold text-navy-950" data-id="element-110" data-mp="26f7yxq0rfhyg">
                {i + 1}
              </span>
              <span className="text-lg font-semibold leading-snug text-white" data-id="element-111" data-mp="2y6ds1mi2cfe8">{q}</span>
            </li>)}
        </ol>

        <p className="mt-10 text-center font-display text-2xl font-semibold uppercase text-white" data-id="element-112" data-mp="2pbpnjykbb1qh">
          That's why I created Implant Risk Radar™.
        </p>

        <SectionCta label="Show me what to watch for" tone="dark" data-id="element-113" data-mp="2kb1xbf3wqoxb" />
      </div>
    </section>;
}